module.exports = __webpack_public_path__ + "img/vehicle_Reports.2b5064e9.png";